import React from "react";
import "./Why_Choose_Shore.css";
import { Container, Row, Col } from "react-bootstrap";
import Common_title from "../../common-components/common_title/Common_title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Why_Choose_Shore = () => {
  const leftPoints = [
    {
      icon: "/assets/images/home/why-choose/left-1.png",
      text: "DG Shipping Approved & ISO-Certified Facility",
    },
    {
      icon: "/assets/images/home/why-choose/left-2.png",
      text: "11+ Years of Marine Health Experience",
    },
    {
      icon: "/assets/images/home/why-choose/left-3.png",
      text: "Accurate, Ethical & Fully Compliant Medical Assessments",
    },
  ];

  const rightPoints = [
    {
      icon: "/assets/images/home/why-choose/right-1.png",
      text: "Fast, Transparent Medical Reporting",
    },
    {
      icon: "/assets/images/home/why-choose/right-2.png",
      text: "Convenient Pune Location (Kothrud)",
    },
    {
      icon: "/assets/images/home/why-choose/right-3.png",
      text: "Friendly, Professional & Multilingual Staff",
    },
  ];

  const centerImages = [
    "/assets/images/clinic-photos/clinic1.jpeg",
    "/assets/images/clinic-photos/clinic2.jpeg",
    "/assets/images/clinic-photos/clinic3.jpeg",
    "/assets/images/clinic-photos/clinic4.jpeg",
  ];
  return (
    <section className="why_choose_section">
      <div className="why_choose_title_holder">
        <Common_title text="⚓ WHY CHOOSE SHORE CLINIC" />
      </div>
      <div className="why_choose_subtitle_holder">
        <p className="why_choose_subtitle">
          We collaborate with shipping and crewing companies to manage medicals
          for their entire workforce.
        </p>
      </div>

      <Container>
        <Row className="align-items-center justify-content-center">
          {/* LEFT POINTS */}
          <Col lg={3} md={4} className="points_col  order-2 order-md-1">
            <div className="points_wrapper left">
              {leftPoints.map((item, index) => (
                <div className="point_box" key={index}>
                  <p className="choose_text">{item.text}</p>
                  <div className="icon_holder">
                    <img src={item.icon} alt="icon" className="choose_icons" />
                  </div>
                </div>
              ))}
            </div>
          </Col>

          {/* CENTER IMAGE */}
          <Col lg={4} md={4} className="text-center order-1 order-md-2">
            <div className="center_img_holder">
              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                loop={true}
                className="center_swiper"
              >
                {centerImages.map((img, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={img}
                      alt={`Center ${index}`}
                      className="center_img"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>

          {/* RIGHT POINTS */}
          <Col lg={3} md={4} className="points_col order-3 order-md-3">
            <div className="points_wrapper">
              {rightPoints.map((item, index) => (
                <div className="point_box" key={index}>
                  <div className="icon_holder">
                    <img src={item.icon} alt="icon" className="choose_icons" />
                  </div>
                  <p className="choose_text">{item.text}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Why_Choose_Shore;
